import React from "react"
import { Attributes } from "html-react-parser/lib/attributes-to-props"
import FlexTable from "./flex-table"

interface IProgramDeliveryTableProps {
  children: React.ReactNode
}
interface IProgramDeliveryTableWithAttributesProps {
  children: React.ReactNode
  attribs: Attributes
}

function ProgramDeliveryTable(props: IProgramDeliveryTableProps): JSX.Element {
  const [keyword, setKeyword] = React.useState<string>(``)
  const table = props.children[0]
  const tableBody = table.props.children[1]
  const tableRows = tableBody.props.children
  const rows = tableRows
    .filter(row =>
      `${row.props.children[0].props.children} ${row.props.children[1].props.children} ${row.props.children[2].props.children} ${row.props.children[3].props.children} ${row.props.children[4].props.children} ${row.props.children[5].props.children}`
        .toLowerCase()
        .includes(keyword.toLowerCase())
    )
    .map(row => {
      const tds = row.props.children
      return [
        <div key={0}>{tds[0].props.children}</div>,
        <div key={1}>
          <a
            target="_blank"
            href={`https://www.georgiancollege.ca/${tds[0].props.children}`}
            rel="noreferrer"
          >
            {tds[1].props.children}
          </a>
        </div>,
        <div key={2}>{tds[2].props.children}</div>,
        <div key={3}>{tds[3].props.children}</div>,
        <div key={4}>{tds[4].props.children}</div>,
        <div key={5}>{tds[5].props.children}</div>,
      ]
    })
  // console.log({ rows })
  return (
    <div className="wp-block-georgiancollege-program-delivery">
      <div className="flex gap-2 items-center">
        <label>Search: </label>
        <input
          className="text-base border px-2 py-1"
          type="text"
          placeholder="Keyword search"
          onChange={e => setKeyword(e.target.value)}
        />
      </div>
      <FlexTable
        initialSortColumn={1}
        maxHeight={500}
        mobileColumnLabels={false}
        // footer={
        //   <Fragment>
        //     Showing {filteredJobs.length} of {jobs.length} jobs
        //   </Fragment>
        // }
        rows={rows}
        className="wp-block-georgiancollege-articulations mt-4"
        headings={[
          {
            label: `Program Code`,
            width: `w-1/12`,
          },
          {
            label: `Program Title`,
            width: `w-4/12`,
          },
          {
            label: `Location(s)`,
            width: `w-1/12`,
          },
          {
            label: `Credential Type`,
            width: `w-3/12`,
          },
          {
            label: `Program Start`,
            width: `w-3/12`,
          },
          {
            label: `CIP Codes`,
            width: `w-2/12`,
          },
        ]}
      />
    </div>
  )
}
export default ProgramDeliveryTable
